import {useTopicQuery} from "../../../../types.d";
import * as React from 'react';
import {RouteComponentProps} from "react-router";
import {EditTopic} from "./EditTopic";

export const EditTopicTab = (props: RouteComponentProps<{ topic: string }>) => {
    const topic = useTopicQuery({
        variables: { id: Number(props.match.params.topic) }
    });

    if (!topic.data) {
        return <h2>Loading...</h2>
    }

    const { stage, id } = topic.data.topic;

    return <EditTopic stageId={stage.id} topicId={id} />;
};
